import { Component } from 'react';

/**
 * Catches render/effect errors in its subtree so a single crashing component
 * (e.g. the Google login button when VITE_GOOGLE_CLIENT_ID is missing) no
 * longer tears down the whole React root and leaves a blank/invisible UI.
 *
 * Pass `fallback` to render something in place of the crashed subtree. When no
 * fallback is given it renders nothing, which keeps the surrounding UI alive.
 */
export default class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        // Keep the real (un-minified in dev, mapped via sourcemaps in prod) error
        // in the console so the root cause is visible instead of a bare `_.zd`.
        console.error('ErrorBoundary caught an error:', error, info?.componentStack);
    }

    render() {
        if (this.state.hasError) {
            return this.props.fallback ?? null;
        }
        return this.props.children;
    }
}
